// components
import { SideEditorPanel } from '@components/SideEditor/SideEditor';
import type { FC } from 'react';

// types and consts
import { MenuItemsIndexDictionary } from '../../consts';
import { EmailSignatureSideEditorItems } from '../../types';
import EmailSignatureEditorContactSection from './EmailSignatureEditorContactSection';
import EmailSignatureEditorPersonalSection from './EmailSignatureEditorPersonalSection';

const EmailSignatureSideEditorDetailsPanel: FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <SideEditorPanel index={MenuItemsIndexDictionary[EmailSignatureSideEditorItems.DETAILS]}>
      <EmailSignatureEditorPersonalSection />
      <EmailSignatureEditorContactSection />
    </SideEditorPanel>
  );
};

export default EmailSignatureSideEditorDetailsPanel;
